!function(t) {
    var e = {};
    function i(s) {
        if (e[s]) return e[s].exports;
        var o = e[s] = {
            i: s,
            l: !1,
            exports: {}
        };
        return t[s].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }
    i.m = t, i.c = e, i.d = function(t, e, s) {
        i.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: s
        });
    }, i.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, i.t = function(t, e) {
        if (1 & e && (t = i(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var s = Object.create(null);
        if (i.r(s), Object.defineProperty(s, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var o in t)i.d(s, o, (function(e) {
            return t[e];
        }).bind(null, o));
        return s;
    }, i.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return i.d(e, "a", e), e;
    }, i.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 10);
}({
    0: function(t, e, i) {
        "use strict";
        function s(t, e) {
            for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
            return t;
        }
        function o() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 600;
        }
        i.d(e, "c", function() {
            return s;
        }), i.d(e, "d", function() {
            return o;
        }), i.d(e, "h", function() {
            return n;
        }), i.d(e, "g", function() {
            return r;
        }), i.d(e, "f", function() {
            return h;
        }), i.d(e, "e", function() {
            return a;
        }), i.d(e, "a", function() {
            return l;
        }), i.d(e, "b", function() {
            return c;
        }), Number.prototype.clamp = function(t, e) {
            return Math.min(Math.max(this, t), e);
        };
        const n = (t)=>t[Math.floor(Math.random() * t.length)];
        function r(t, e) {
            return null == t && (t = 0), null == e && (e = 1), t + Math.random() * (e - t);
        }
        function h(t, e) {
            return null == t && (t = 0), null == e && (e = 1), Math.floor(t + Math.random() * (e - t + 1));
        }
        var a = (t)=>document.querySelector(t);
        const l = (t)=>"number" == typeof t ? "#" + ("00000" + t.toString(16)).slice(-6) : t, c = (t, e = 1)=>{
            const i = l(t), s = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(i), o = s ? {
                r: parseInt(s[1], 16),
                g: parseInt(s[2], 16),
                b: parseInt(s[3], 16)
            } : null;
            return "rgba(" + o.r + "," + o.g + "," + o.b + "," + e + ")";
        };
    },
    1: function(t, e, i) {
        "use strict";
        i.d(e, "a", function() {
            return o;
        });
        var s = i(0);
        window && !window.VANTA && (window.VANTA = {
            version: "0.3.1"
        });
        const o = window.VANTA || {};
        o.register || (o.register = (t, e)=>{
            o[t] = (t)=>new e(t);
        });
        var n = function() {
            return Array.prototype.unshift.call(arguments, "[VANTA]"), console.error.apply(this, arguments);
        };
        o.VantaBase = class {
            constructor(t = {}){
                var e, i, r, h;
                if (o.current = this, this.onMouseMoveWrapper = this.onMouseMoveWrapper.bind(this), this.resize = this.resize.bind(this), this.animationLoop = this.animationLoop.bind(this), this.restart = this.restart.bind(this), this.options = Object(s.c)({}, this.defaultOptions), t instanceof HTMLElement || "string" == typeof t ? Object(s.c)(this.options, {
                    el: t
                }) : Object(s.c)(this.options, t), this.el = this.options.el, null == this.el) n('Instance needs "el" param!');
                else if (!(this.options.el instanceof HTMLElement || (h = this.el, this.el = Object(s.e)(h), this.el))) return void n("Cannot find element", h);
                for(r = 0; r < this.el.children.length; r++)e = this.el.children[r], "static" === getComputedStyle(e).position && (e.style.position = "relative"), "auto" === getComputedStyle(e).zIndex && (e.style.zIndex = 1);
                "static" === getComputedStyle(this.el).position && (this.el.style.position = "relative"), "object" == typeof THREE && this.initThree(), this.setSize(), this.uniforms = {
                    u_time: {
                        type: "f",
                        value: 1
                    },
                    u_resolution: {
                        type: "v2",
                        value: new THREE.Vector2(1, 1)
                    },
                    u_mouse: {
                        type: "v2",
                        value: new THREE.Vector2(0, 0)
                    }
                };
                try {
                    this.init();
                } catch (t) {
                    return i = t, n("Init error"), n(i), this.el.removeChild(this.renderer.domElement), void (this.options.backgroundColor && (console.log("[VANTA] Falling back to backgroundColor"), this.el.style.background = this.color2Hex(this.options.backgroundColor)));
                }
                window.addEventListener("resize", this.resize), this.resize(), this.animationLoop(), this.el.addEventListener("mousemove", this.onMouseMoveWrapper, !1), window.addEventListener("scroll", this.onMouseMoveWrapper);
            }
            applyCanvasStyles(t, e = {}) {
                Object(s.c)(t.style, {
                    position: "absolute",
                    zIndex: 0,
                    top: 0,
                    left: 0,
                    background: ""
                }), Object(s.c)(t.style, e), t.classList.add("vanta-canvas");
            }
            initThree() {
                this.renderer = new THREE.WebGLRenderer({
                    alpha: !0,
                    antialias: !0
                }), this.el.appendChild(this.renderer.domElement), this.applyCanvasStyles(this.renderer.domElement), isNaN(this.options.backgroundAlpha) && (this.options.backgroundAlpha = 1), this.scene = new THREE.Scene;
            }
            onMouseMoveWrapper(t) {
                var e, i, s;
                e = this.renderer.domElement.getBoundingClientRect(), i = this.mouseX = t.clientX - e.left, s = this.mouseY = t.clientY - e.top, i >= 0 && s >= 0 && !this.options.mouseEase && this.triggerMouseMove(i, s);
            }
            triggerMouseMove(t, e) {
                this.uniforms && (this.uniforms.u_mouse.value.x = t / this.scale, this.uniforms.u_mouse.value.y = e / this.scale);
                const i = t / this.width, s = e / this.height;
                "function" == typeof this.onMouseMove && this.onMouseMove(i, s);
            }
            setSize() {
                this.scale || (this.scale = 1), Object(s.d)() && this.options.scaleMobile ? this.scale = this.options.scaleMobile : this.options.scale && (this.scale = this.options.scale), this.width = this.el.offsetWidth || window.innerWidth, this.height = this.el.offsetHeight || window.innerHeight;
            }
            resize() {
                var t, e;
                this.setSize(), null != (t = this.camera) && (t.aspect = this.width / this.height), null != (e = this.camera) && "function" == typeof e.updateProjectionMatrix && e.updateProjectionMatrix(), this.renderer && (this.renderer.setSize(this.width, this.height), this.renderer.setPixelRatio(window.devicePixelRatio / this.scale)), "function" == typeof this.onResize && this.onResize();
            }
            animationLoop() {
                var t, e, i, s, o, n, r, h;
                return this.t || (this.t = 0), this.t += 1, this.t2 || (this.t2 = 0), this.t2 += null != (n = this.options.speed) ? n : 1, this.uniforms && (this.uniforms.u_time.value = .016667 * this.t2), t = this.el.offsetHeight, e = this.el.getBoundingClientRect(), h = null != (r = window.pageYOffset) ? r : (document.documentElement || document.body.parentNode || document.body).scrollTop, s = (o = e.top + h) - window.innerHeight, i = o + t, this.options.mouseEase && (this.mouseEaseX = this.mouseEaseX || this.mouseX || 0, this.mouseEaseY = this.mouseEaseY || this.mouseY || 0, Math.abs(this.mouseEaseX - this.mouseX) + Math.abs(this.mouseEaseY - this.mouseY) > .1 && (this.mouseEaseX = this.mouseEaseX + .05 * (this.mouseX - this.mouseEaseX), this.mouseEaseY = this.mouseEaseY + .05 * (this.mouseY - this.mouseEaseY), this.triggerMouseMove(this.mouseEaseX, this.mouseEaseY))), s <= h && h <= i && ("function" == typeof this.onUpdate && this.onUpdate(), this.scene && this.camera && (this.renderer.render(this.scene, this.camera), "transparent" == this.options.backgroundColor ? this.renderer.setClearColor(this.options.backgroundColor, 0) : this.renderer.setClearColor(this.options.backgroundColor, this.options.backgroundAlpha)), this.fps && this.fps.update && this.fps.update()), this.req = window.requestAnimationFrame(this.animationLoop);
            }
            restart() {
                if (this.scene) for(; this.scene.children.length;)this.scene.remove(this.scene.children[0]);
                "function" == typeof this.onRestart && this.onRestart(), this.init();
            }
            init() {
                "function" == typeof this.onInit && this.onInit();
            }
            destroy() {
                "function" == typeof this.onDestroy && this.onDestroy(), this.el.removeEventListener("mousemove", this.onMouseMoveWrapper), window.removeEventListener("scroll", this.onMouseMoveWrapper), window.removeEventListener("resize", this.resize), window.cancelAnimationFrame(this.req), this.renderer && (this.el.removeChild(this.renderer.domElement), this.renderer = null, this.scene = null);
            }
        }, e.b = o.VantaBase;
    },
    10: function(t, e, i) {
        "use strict";
        i.r(e);
        var s = i(1), o = i(0);
        THREE.Color.prototype.getBrightness = function() {
            return .299 * this.r + .587 * this.g + .114 * this.b;
        };
        class n extends s.b {
            static initClass() {
                this.prototype.defaultOptions = {
                    color: 16727937,
                    backgroundColor: 2299196,
                    points: 10,
                    maxDistance: 20,
                    spacing: 15,
                    showDots: !0
                };
            }
            genPoint(t, e, i) {
                let s;
                if (this.points || (this.points = []), this.options.showDots) {
                    const t = new THREE.SphereGeometry(.25, 12, 12), e = new THREE.MeshLambertMaterial({
                        color: this.options.color
                    });
                    s = new THREE.Mesh(t, e);
                } else s = new THREE.Object3D;
                return this.cont.add(s), s.ox = t, s.oy = e, s.oz = i, s.position.set(t, e, i), s.r = Object(o.g)(-2, 2), this.points.push(s);
            }
            onInit() {
                this.cont = new THREE.Group, this.cont.position.set(0, 0, 0), this.scene.add(this.cont);
                let t = this.options.points, { spacing: e } = this.options;
                Object(o.d)() && (t = ~~(.75 * t), e = ~~(.65 * e));
                const i = t * t * 2;
                this.linePositions = new Float32Array(i * i * 3), this.lineColors = new Float32Array(i * i * 3);
                const s = new THREE.Color(this.options.color).getBrightness(), n = new THREE.Color(this.options.backgroundColor).getBrightness();
                this.blending = s > n ? "additive" : "subtractive";
                const r = new THREE.BufferGeometry;
                r.addAttribute("position", new THREE.BufferAttribute(this.linePositions, 3).setDynamic(!0)), r.addAttribute("color", new THREE.BufferAttribute(this.lineColors, 3).setDynamic(!0)), r.computeBoundingSphere(), r.setDrawRange(0, 0);
                const h = new THREE.LineBasicMaterial({
                    vertexColors: THREE.VertexColors,
                    blending: "additive" === this.blending ? THREE.AdditiveBlending : null,
                    transparent: !0
                });
                this.linesMesh = new THREE.LineSegments(r, h), this.cont.add(this.linesMesh);
                for(let i = 0; i <= t; i++)for(let s = 0; s <= t; s++){
                    const n = Object(o.f)(-3, 3), r = (i - t / 2) * e + Object(o.f)(-5, 5);
                    let h = (s - t / 2) * e + Object(o.f)(-5, 5);
                    i % 2 && (h += .5 * e), this.genPoint(r, n - Object(o.f)(5, 15), h), this.genPoint(r + Object(o.f)(-5, 5), n + Object(o.f)(5, 15), h + Object(o.f)(-5, 5));
                }
                this.camera = new THREE.PerspectiveCamera(25, this.width / this.height, .01, 1e4), this.camera.position.set(50, 100, 150), this.scene.add(this.camera);
                const a = new THREE.AmbientLight(16777215, .75);
                return this.scene.add(a), this.spot = new THREE.SpotLight(16777215, 1), this.spot.position.set(0, 200, 0), this.spot.distance = 400, this.spot.target = this.cont, this.scene.add(this.spot);
            }
            onUpdate() {
                let t;
                null != this.helper && this.helper.update(), null != this.controls && this.controls.update();
                const e = this.camera;
                Math.abs(e.tx - e.position.x) > .01 && (t = e.tx - e.position.x, e.position.x += .02 * t), Math.abs(e.ty - e.position.y) > .01 && (t = e.ty - e.position.y, e.position.y += .02 * t), e.lookAt(new THREE.Vector3(0, 0, 0));
                let i = 0, s = 0, o = 0;
                const n = new THREE.Color(this.options.backgroundColor), r = new THREE.Color(this.options.color), h = r.clone().sub(n);
                this.rayCaster && this.rayCaster.setFromCamera(new THREE.Vector2(this.rcMouseX, this.rcMouseY), this.camera);
                for(let t = 0; t < this.points.length; t++){
                    var a;
                    const e = this.points[t], c = (this.rayCaster ? this.rayCaster.ray.distanceToPoint(e.position) : 1e3).clamp(5, 15);
                    if (e.scale.x = e.scale.y = e.scale.z = (.25 * (15 - c)).clamp(1, 100), 0 !== e.r) {
                        let t = Math.atan2(e.position.z, e.position.x);
                        a = Math.sqrt(e.position.z * e.position.z + e.position.x * e.position.x), t += 25e-5 * e.r, e.position.x = a * Math.cos(t), e.position.z = a * Math.sin(t);
                    }
                    for(let c = t; c < this.points.length; c++){
                        const t = this.points[c], u = e.position.x - t.position.x, p = e.position.y - t.position.y, d = e.position.z - t.position.z;
                        if ((a = Math.sqrt(u * u + p * p + d * d)) < this.options.maxDistance) {
                            var l;
                            const c = (2 * (1 - a / this.options.maxDistance)).clamp(0, 1);
                            l = "additive" === this.blending ? new THREE.Color(0).lerp(h, c) : n.clone().lerp(r, c), this.linePositions[i++] = e.position.x, this.linePositions[i++] = e.position.y, this.linePositions[i++] = e.position.z, this.linePositions[i++] = t.position.x, this.linePositions[i++] = t.position.y, this.linePositions[i++] = t.position.z, this.lineColors[s++] = l.r, this.lineColors[s++] = l.g, this.lineColors[s++] = l.b, this.lineColors[s++] = l.r, this.lineColors[s++] = l.g, this.lineColors[s++] = l.b, o++;
                        }
                    }
                }
                return this.linesMesh.geometry.setDrawRange(0, 2 * o), this.linesMesh.geometry.attributes.position.needsUpdate = !0, this.linesMesh.geometry.attributes.color.needsUpdate = !0, .001 * this.t;
            }
            onMouseMove(t, e) {
                const i = this.camera;
                i.oy || (i.oy = i.position.y, i.ox = i.position.x, i.oz = i.position.z);
                const s = Math.atan2(i.oz, i.ox), o = Math.sqrt(i.oz * i.oz + i.ox * i.ox), n = s + 2 * (t - .5) * (this.options.mouseCoeffX || 1);
                return i.tz = o * Math.sin(n), i.tx = o * Math.cos(n), i.ty = i.oy + 10 * (e - .5) * (this.options.mouseCoeffY || 1), this.rayCaster, this.rcMouseX = 2 * t - 1, this.rcMouseY = 2 * -t + 1;
            }
            onRestart() {
                this.scene.remove(this.linesMesh), this.points = [];
            }
        }
        n.initClass(), s.a.register("NET", n);
    }
});

//# sourceMappingURL=app.df121372.js.map
